import { render, staticRenderFns } from "./AllReviewList.vue?vue&type=template&id=b54c582c&scoped=true"
import script from "./AllReviewList.vue?vue&type=script&lang=js"
export * from "./AllReviewList.vue?vue&type=script&lang=js"
import style0 from "./AllReviewList.vue?vue&type=style&index=0&id=b54c582c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54c582c",
  null
  
)

export default component.exports